import {Component, React} from '$src/handy'
import {observer} from 'mobx-react'

@observer
export default class NotFoundPage extends Component<{}, {}> {
  render() {
    return '404'
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/routing/NotFoundPage.tsx